
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Story',
	'noDashboardFound': 'De story kan niet worden opgehaald. Het object bestaat niet meer of u beschikt niet over de machtiging om het te bekijken.',
	'noDashboardCapability': 'U hebt bent niet bevoegd voor het gebruik van story\'s',
	'noDashboardPermision': 'U hebt onvoldoende bevoegdheden om deze story te bekijken',
	'defaultName': 'Nieuwe story',
	'storyProperties': 'Story-eigenschappen',
	'createAvDataStoryLabel': 'Story',
	'createAvSlideShowLabel': 'Diapresentatie',
	'createAvPanAndZoomLabel': 'Begeleid traject',
	'dashboard_save_success': 'Uw story is opgeslagen.',
	'cmEmptySelection': 'De story is gewist. Probeer hem op te slaan als een nieuwe story.',
	'createStoryTitle': 'Een story maken',
	'transitionStyleTitle': 'Overgangsstijl',
	'createButton': 'Maken',
	'cancelButton': 'Annuleren',
	'dashboardResetTitle': 'Story resetten',
	'dashboardResetMessage': 'Weet u zeker dat u alle wijzigingen die in deze story zijn aangebracht, wilt resetten?',
	'dashboardResetToast': 'Uw story is gereset.',
	'filter_drag_and_drop_all_tabs': 'Gegevens hiernaartoe verslepen om alle scènes te filteren',
	'filter_drag_and_drop_current_tab': 'Gegevens hiernaartoe verslepen om deze scène te filteren',
	'filterIconLabel_Global': 'Alle scènes',
	'filterIconLabel_Tab': 'Deze scène',
	'filterIconTooltip_Global': 'Alle scènes',
	'filterIconTooltip_Tab': 'Deze scène',
	'filterOverflowMenu_Global': 'Overloopmenu voor alle scènes',
	'filterOverflowMenu_Tab': 'Overloopmenu voor deze scène',
	'renameScene': 'Scène hernoemen',
	'duplicateScene': 'Scène dupliceren',
	'deleteScene': 'Scène wissen',
	'editTimelineHighlight': 'Accentuering bewerken',
	'deleteTimelineHighlight': 'Accentuering wissen',
	'filter_includesAll': 'Inclusief alle',
	'timeline_highlight_moved_to': 'Tijdlijnaccentuering %{id} verplaatst naar %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Selecteren',
	'newDefaultStoryName': 'Story: %{modelName}',
	'exportLabel': 'Opslaan',
	'exportAsLabel': 'Opslaan als:',
	'exportDialogTitle': 'Opslaan als story',
	'exportDialogFooter': 'Knoppen voor opslaan en annuleren',
	'loadAfterExportLabel': 'Story na het opslaan openen',
	'selectTemplateLabel': 'Selecteer een sjabloon',
	'outOfBoundsWarningMessage': 'Bepaalde dashboardwidgets vallen buiten het raster en worden na het exporteren misschien niet goed afgebeeld.',
	'emptyExploreCardsWarningMessage': 'Lege kaarten zijn tijdens de opslagbewerking als story gewist.',
	'dashboard_export_success': 'Uw dashboard is opgeslagen als een story.',
	'explore_export_success': 'Uw verkenning is opgeslagen als een story.',
	'toastUpgradeDone': 'Uw story is geüpgraded. Sla nu op om optimale prestaties te handhaven.',
	'navigationMarker': 'Navigatiemarkering',
	'navigateMarkers': 'Navigatiemarkeringen',
	'navNextMarker': 'Volgende markering',
	'navPrevMarker': 'Vorige markering',
	'navPrevMarkerAbbreviated': 'Vor. markering',
	'timelineSettingsButton': 'Afspeelopties',
	'autoPlay': 'Alle scènes afspelen',
	'loop': 'Herhalen',
	'refreshData': 'Vernieuwen bij start',
	'slideshowLabel': 'Diapresentatie',
	'panAndZoomLabel': 'Begeleid traject',
	'slideShowLayoutLabel': 'Indeling met diapresentatie',
	'panAndZoomLayoutLabel': 'Indeling met begeleid traject',
	'panAndZoomLayoutFooter': 'Een indeling van een begeleid traject is een collectie van scènes op een enkel canvas. Als u dit type story uitvoert, zoomt en pant de presentatie op elke afzonderlijke scène in sequentiële volgorde. Dit is anders dan een diapresentatie, waarbij elke scène op een nieuw canvas gepresenteerd wordt. Met behulp van de indeling voor het begeleide traject met drie scènes die verbonden zijn met lijnen kunt u een horizontale reeks scènes maken. Dit is handig voor het afbeelden van een tijdlijn.',
	'PanAndZoomLayout1': '5 scènes geordend in een rechthoekige vorm',
	'PanAndZoomLayout2': '4 scènes geordend in een trapvorm die van links naar rechts omhoog gaat',
	'PanAndZoomLayout3': '6 scènes geordend in een rechthoekige vorm',
	'PanAndZoomLayout4': '7 scènes geordend in een rechthoekige vorm, met 6 kleine scènes bovenaan en 1 grote scène onderaan',
	'PanAndZoomLayout5': '3 scènes, geordend met 2 kleine scènes bovenaan en 1 grote scène onderaan',
	'PanAndZoomLayout6': 'Een reeks van 4 scènes die horizontaal geordend zijn',
	'pageSelectWarning': 'Selecteer een scène.',
	'noSceneTransitionLabel': 'Geen',
	'sceneTransitionPropertyLabel': 'Scèneovergang',
	'animatedPathSceneTransitionLabel': 'Geanimeerd pad',
	'sweepSceneTransitionLabel': 'Opschoning',
	'storyTypeLabel': 'Type story',
	'layoutLabel': 'Layout',
	'tabName_animation': 'Animatie',
	'propAniAnimation': 'Animatie',
	'propAniTypeEntrance': 'Ingangsanimatie',
	'propAniDirectionIn': 'Ingangsrichting',
	'propAniTypeExit': 'Uitgangsanimatie',
	'propAniDirectionOut': 'Uitgangsrichting',
	'propAniDirection': 'Richting',
	'propAniEntrance': 'Ingang',
	'propAniTypeEntranceSlideIn': 'Inschuiven',
	'propAniTypeEntranceFadeIn': 'Infaden',
	'propAniTypeEntrancePivotIn': 'Indraaien',
	'propAniTypeEntranceScaleIn': 'Inschalen',
	'propAniTypeEntranceShrinkIn': 'Inkrimpen',
	'propAniDirectionInLeft': 'Van links',
	'propAniDirectionInRight': 'Van rechts',
	'propAniDirectionInTop': 'Van boven',
	'propAniDirectionInBottom': 'Van onderen',
	'propAniExit': 'Afsluiten',
	'propAniTypeExitSlideIn': 'Uitschuiven',
	'propAniTypeExitFadeIn': 'Uitfaden',
	'propAniTypeExitPivotOut': 'Uitdraaien',
	'propAniTypeExitScaleIn': 'Uitschalen',
	'propAniTypeExitExpandOut': 'Uitbreiden',
	'propAniDirectionOutLeft': 'Naar links',
	'propAniDirectionOutRight': 'Naar rechts',
	'propAniDirectionOutTop': 'Naar boven',
	'propAniDirectionOutBottom': 'Naar beneden',
	'propAniEntranceTime': 'Beginnen op (secs):',
	'propAniExitTime': 'Eindigen op (secs):',
	'animationNoEntranceText': 'Opkomstanimatie vindt niet plaats als de widget zich aan het begin van een scène bevindt.',
	'animationNoExitText': 'Sluitingsanimatie vindt niet plaats als de widget zich aan het eind van een scène bevindt.',
	'propAniTypeDataEntrance': 'Gegevensingang',
	'propAniRevealDuration': 'Duur van opkomstanimatie',
	'timelineAnimationProperties': 'Eigenschappen voor animatie openen',
	'scenesPropertiesSection': 'Scènes',
	'editStoryCoachMarkTitle': 'Story bewerken',
	'editStoryCoachMarkContents': 'Klik op het potloodpictogram om deze story te bewerken.',
	'addDataStoryCoachMarkContents': 'Sleep gegevens vanuit het gegevensscherm naar uw story.',
	'expandSceneCoachmarkTitle': 'Tijdlijn openen',
	'expandSceneCoachmarkContents': 'Een scène animeren door de zichtbaarheid van een object aan te passen aan tijd en datum.',
	'overviewCoachmarkTitle': 'Overzichtsscènes',
	'overviewCoachmarkContents': 'Met de overzichtsscènes aan het begin en eind van uw story kunt u het algehele beeld van alle scènes presenteren. Vanuit een overzichtsscène klikt en sleept u een scène om hem te verwisselen met een andere scène. U kunt de overzichtsscènes afbeelden of verbergen in de eigenschappen van de story.',
	'animatedPathCoachmarkTitle': 'Geanimeerd pad',
	'animatedPathCoachmarkContents': 'Om een object van de ene scène naar een andere te animeren, dupliceert u een scène met een object. Verplaats, vergroot/verklein of roteer het gedupliceerde object vervolgens in de nieuwe scène.',
	'propShowStoryOverviewFirstSlide': 'Alle scènes aan het begin afbeelden',
	'propShowStoryOverviewLastSlide': 'Alle scènes aan het einde afbeelden',
	'storySceneSingleCountLabel': '1 scène',
	'storySceneCountLabel': '%{count} scènes',
	'storySceneRangeCountLabel': 'Scène %{index} of %{count}',
	'storySceneExpand': 'Tijdlijn openen',
	'storySceneActionMenu': 'Menu voor startopties van scènes',
	'timelineRightContainerLabel': 'Stuurgroep knoppen op tijdlijn',
	'timelineViewLabel': 'Tijdlijn',
	'timelineZoomFit': 'Inzoomen tot passend formaat',
	'timelineZoomIn': 'Inzoomen',
	'timelineZoomOut': 'Uitzoomen',
	'timelinePositionIndicator': 'indicator tijdlijnpositie op %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'indicator tijdlijnpositie naar links verplaatsen naar %{position}',
	'timelinePositionIndicatorMoveRightTo': 'indicator tijdlijnpositie naar rechts verplaatsen naar %{position}',
	'sceneStart': 'Naar het begin van de scène springen, naar %{position}',
	'sceneEnd': 'Naar het einde van de scène springen, naar %{position}',
	'timelineHighlightTitle': 'Accentuering',
	'addTimelineHighlight': 'Accentuering toevoegen',
	'addSceneBtnTitle': 'Nieuwe scène met standaardsjabloon toevoegen',
	'addSceneChevronBtnTitle': 'Scènesjabloon selecteren',
	'timelinePlay': 'Afspelen',
	'timelinePause': 'Pauzeren',
	'sceneNavigation': 'Scènenavigatie',
	'navNextScene': 'Volgende scène',
	'navPrevScene': 'Vorige scène',
	'navPrevSceneAbbreviated': 'Vor. scène',
	'navExitFullScreen': 'Volledig scherm afsluiten',
	'navToggleOverview': 'Overzicht weergeven of verbergen',
	'rowNumber': 'Rij %{number}',
	'overviewBtnLabel': 'Overzicht',
	'sceneListStart': 'Begin van overzicht',
	'sceneListEnd': 'Einde van overzicht',
	'timelineLeftHandle': 'linkerhandvat voor %{name}',
	'timelineRightHandle': 'rechterhandvat voor %{name}',
	'timelineLeftHandleNoTitle': 'linkerhandvat',
	'timelineRightHandleNoTitle': 'rechterhandvat',
	'timelineMoveLeft': '%{object} naar links verplaatsen',
	'timelineMoveRight': '%{object} naar rechts verplaatsen',
	'timelineMoveWidget': 'tijdlijnwidget verplaatst naar %{newStartTime} en %{newEndTime}',
	'timelineMoveWidgetStartTime': 'begintijd van tijdlijnwidget gewijzigd in %{newStartTime}',
	'timelineMoveWidgetEndTime': 'eindtijd van tijdlijnwidget gewijzigd in %{newEndTime}',
	'timelineMoveWidgetDown': 'tijdlijnwidget omlaag verplaatst',
	'timelineMoveWidgetUp': 'tijdlijnwidget omhoog verplaatst',
	'addSceneTitle': 'Een scène toevoegen',
	'blankSceneLayout': 'Leeg',
	'titleSceneLayout': 'Titel met subtitel',
	'sceneLayout1': 'Titel met tekst naast één visualisatie',
	'sceneLayout2': 'Titel met één visualisatie',
	'sceneLayout3': 'Titel met twee visualisaties',
	'sceneLayout4': 'Multifunctioneel',
	'sceneLayout5': 'Geen titel met tekst naast één visualisatie',
	'sceneLayout6': 'Multifunctioneel 2 bij 2',
	'sceneLayout7': 'Multifunctioneel 2 naast 1',
	'sceneLayout8': 'Multifunctioneel 1 naast 2',
	'sceneLayout9': 'Multifunctioneel 1 boven 2',
	'sceneLayout10': 'Multifunctioneel 2 boven 1',
	'sceneLayout11': 'Multifunctioneel 4 boven 1',
	'sceneLayout12': 'Multifunctioneel 1 boven 1 naast 2 bij 2 boven 1',
	'titleWidgetPlaceholderText': 'Voer hier uw titel in',
	'subtitleWidgetPlaceholderText': 'Voer hier uw subtitel in',
	'createStoryViewTitle': 'Story maken',
	'defaultStoryName': 'Nieuwe story',
	'screenshot_label': 'Story %{title}',
	'screenshot_label_scene': 'Scène %{sceneTitle} van story %{title}',
	'filmstripHandleOpenLabel': 'Scèneselector openen',
	'filmstripHandleCloseLabel': 'Scèneselector sluiten'
});
